import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { useQueryWithDecoder } from '../../../../UseQueryWithDecoder';
import CardTitle from '../../Shared/CardTitle';
import PopularCompetenciesList from '../PopularCompetenciesList';
import { popularCompetenciesResourceDecoder } from './Decoder';
import PopularCompetenciesSkeleton from './PopularCompetenciesSkeleton';

function PopularCompetencies() {
  const { data, isLoading, error } = useQueryWithDecoder(
    'popular-competencies',
    currentUserStore.links,
    popularCompetenciesResourceDecoder,
  );

  if (isLoading) {
    return (
      <div className="w-[47.4%] mb-4 mt-7">
        <PopularCompetenciesSkeleton />
      </div>
    );
  }

  if (error || !data) {
    console.error('Failed to load popular competencies:', error);
    return emptyFragment();
  }

  const { payload } = data;
  return (
    <div className="max-w-[48%] grow sm:max-w-full">
      <CardTitle title="Popular Competencies" />
      <PopularCompetenciesList popularCompetencies={payload} />
    </div>
  );
}

export default observer(PopularCompetencies);
